var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 28,
    viewBox: "0 0 48 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 27,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 27,
    rx: 7.5,
    stroke: "#73007D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.25C18.4142 13.25 18.75 13.5858 18.75 14V20C18.75 20.1989 18.829 20.3897 18.9697 20.5303C19.1103 20.671 19.3011 20.75 19.5 20.75H28.5C28.6989 20.75 28.8897 20.671 29.0303 20.5303C29.171 20.3897 29.25 20.1989 29.25 20V14C29.25 13.5858 29.5858 13.25 30 13.25C30.4142 13.25 30.75 13.5858 30.75 14V20C30.75 20.5967 30.5129 21.169 30.091 21.591C29.669 22.0129 29.0967 22.25 28.5 22.25H19.5C18.9033 22.25 18.331 22.0129 17.909 21.591C17.4871 21.169 17.25 20.5967 17.25 20V14C17.25 13.5858 17.5858 13.25 18 13.25Z",
    fill: "#73007D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5303 16.7803C24.2374 17.0732 23.7626 17.0732 23.4697 16.7803L20.4697 13.7803C20.1768 13.4874 20.1768 13.0126 20.4697 12.7197C20.7626 12.4268 21.2374 12.4268 21.5303 12.7197L23.25 14.4393L23.25 6.5C23.25 6.08579 23.5858 5.75 24 5.75C24.4142 5.75 24.75 6.08579 24.75 6.5L24.75 14.4393L26.4697 12.7197C26.7626 12.4268 27.2374 12.4268 27.5303 12.7197C27.8232 13.0126 27.8232 13.4874 27.5303 13.7803L24.5303 16.7803Z",
    fill: "#73007D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDownload);
export default __webpack_public_path__ + "static/media/ic_download.71975dc3203abe8bc1292fa09924ab5f.svg";
export { ForwardRef as ReactComponent };